import { forwardRef, ComponentProps } from 'react';
import cn from 'clsx';
import { PolymorphicComponent } from '../types';

import styles from './Card.module.scss';

const defaultElement = 'div' as const;

export type CardOwnProps = {
  title?: string | React.ReactElement;
  /** добавлять или нет отступы следующим карточкам
   * @default true
   */
  stack?: boolean;
  /**
   * Фон карточки
   * @default default
   */
  background?: 'transparent' | 'white' | 'default';

  // Отключает отступы внутри картточки
  noPadding?: boolean;
};

type CardComponent = PolymorphicComponent<typeof defaultElement, CardOwnProps>;

export const Card = forwardRef(
  (
    {
      as: Element = defaultElement,
      className,
      title,
      children,
      stack = true,
      background = 'default',
      noPadding,
      ...restProps
    }: ComponentProps<CardComponent>,
    ref
  ) => (
    <Element
      ref={ref}
      className={cn(
        styles.card,
        className,
        styles[`background_${background}`],
        {
          [styles.stack]: stack
        }
      )}
      {...restProps}
    >
      {title && <h3>{title}</h3>}
      <div
        className={cn(styles.cardContent, { [styles.noPadding]: noPadding })}
      >
        {children}
      </div>
    </Element>
  )
) as CardComponent;
